<!-- 车辆保险免费资格查询 -->
<template>
    <div style="margin: 10px;">
        <div style="padding: 10px 0px 0px 0px">
            <van-icon name="arrow-left" style="float: left" size="20px" @click="onback"/>
        </div>
        <div style="height: 25px"></div>
        <div style="text-align: center"><h2>重货保险免费安装主动安全设备登记</h2></div>
        <div v-if="showPic">
            <Form :label-width="80">
                <FormItem label="车牌号:">
                    <div>
                        <Input v-model="rmvehicleinfo.chePaiHao" size="small"
                               clearable
                               placeholder="车牌号"
                               style="width: 220px;padding: 5px"></Input>
                        <Button size="small" type="info" @click="inquireOperationModal">
                            查询
                        </Button>
                        <Drawer title="查询车辆" placement="left" :closable="false" v-model="showDrawer">
                            <div>

                                <Input v-model="rmvehicleinfo.customerCntact" size="small"
                                       clearable
                                       placeholder="客户联系人"
                                       style="width: 220px;padding: 5px"></Input>
                                <Input v-model="rmvehicleinfo.customerCntactPhone" size="small"
                                       clearable
                                       placeholder="客户联系人联系方式"
                                       style="width: 220px;padding: 5px"></Input>
                                <Button size="small" type="info" style="position: relative;left: 170px;top: 10px;"
                                        @click="onFind">
                                    查询
                                </Button>
                            </div>
                            <Divider/>
                            <div v-for="item in rmvehicleinfolist">
                                <div style="margin-bottom: 5px;">
                                    {{item.chePaiHao}}
                                    <Button size="small" type="info" style="position: relative;left: 100px;"
                                            @click="onDetail(item)">
                                        查询
                                    </Button>
                                </div>
                            </div>
                        </Drawer>
                    </div>
                </FormItem>
                <FormItem label="营运是否符合:"
                          v-if="rmvehicleinfo.chePaiHao != null && rmvehicleinfo.chePaiHao != '' && eligibility">
                    <!--                    <div style="margin-bottom: 10px;" v-for="(items,index) in information">{{index}}{{items}}</div>-->
                    <div style="margin-bottom: 10px;"><label
                            :style="eligibility == true ?'color:blue;':'color:red;'">{{eligibility == true ?
                        '符合':'不符合'}}</label></div>
                </FormItem>
                <FormItem label="营运不符合原因原因:"
                          v-if="rmvehicleinfo.chePaiHao != null && rmvehicleinfo.chePaiHao != '' && msg.length>0">
                    <div style="margin-bottom: 10px;" v-for="items in msg"><label
                            :style="eligibility == true ?'color:blue;':'color:red;'">{{items}}</label></div>
                </FormItem>

                <FormItem v-if="rmvehicleinfo.remark != null && rmvehicleinfo.remark != '' && !rmvehicleinfo.auditPass" label="审核不通过原因:">
                    <div style="margin-bottom: 10px;"
                         v-if="rmvehicleinfo.remark != null && rmvehicleinfo.remark != '' && !rmvehicleinfo.auditPass">
                        <label
                                :style="rmvehicleinfo.auditPass == true ?'color:blue;':'color:red;'">{{rmvehicleinfo.remark.split(':')[rmvehicleinfo.remark.split('，').length-1]}}</label>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="车牌颜色:">
                    <div>
                        <!--                        <Input v-model="rmvehicleinfo.chePaiYanSe" size="small"-->
                        <!--                               clearable placeholder="车牌颜色"-->
                        <!--                               style="width: 220px;padding: 5px"></Input>-->
                        <Select v-model="rmvehicleinfo.chePaiYanSe" size="small" style="width: 220px;padding: 5px">
                            <Option v-for="item in chePaiYanSeOptions" :value="item.name" :key="item.value">
                                {{item.name}}
                            </Option>
                        </Select>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="车架号:">
                    <div>
                        <Input v-model="rmvehicleinfo.cheJiaHao" size="small"
                               clearable placeholder="车架号"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="发动机号:">
                    <div>
                        <Input v-model="rmvehicleinfo.faDongJiHao" size="small"
                               clearable placeholder="发动机号"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>

                <FormItem v-if="eligibility" label="地区:">
                    <div>
                        <Select v-model="rmvehicleinfo.area" size="small" style="width: 220px;padding: 5px">
                            <Option v-for="item in certificateAreaOptions" :value="item.name" :key="item.value">
                                {{item.name}}
                            </Option>
                        </Select>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="客户联系人:">
                    <div>
                        <Input v-model="rmvehicleinfo.customerCntact" size="small"
                               clearable placeholder="客户联系人"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="客户联系人联系方式:">
                    <div>
                        <Input v-model="rmvehicleinfo.customerCntactPhone" size="small"
                               clearable placeholder="客户联系人联系方式"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>

                <FormItem v-if="eligibility" label="业户名称:">
                    <div>
                        <Input v-model="rmvehicleinfo.yeHuMingCheng" size="small"
                               clearable placeholder="业户名称"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="身份证号码(个体户):">
                    <div>
                        <Input v-model="rmvehicleinfo.shenFenZhengHaoMa" size="small"
                               clearable placeholder="身份证号码"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="业户统一社会信用代码(企业主体):">
                    <div>
                        <Input v-model="rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa" size="small"
                               clearable placeholder="业户统一社会信用代码"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="业户负责人名称:">
                    <div>
                        <Input v-model="rmvehicleinfo.yeHuFuZeRenXingMing"
                               size="small" clearable placeholder="业户负责人名称"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="业户负责人联系方式:">
                    <div>
                        <Input v-model="rmvehicleinfo.yeHuFuZeRenLianXiFangShi"
                               size="small" clearable placeholder="业户负责人联系方式"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="司机姓名:">
                    <div>
                        <Input v-model="rmvehicleinfo.siJiXingMing" size="small"
                               clearable placeholder="司机姓名"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="从业资格证号:">
                    <div>
                        <Input v-model="rmvehicleinfo.congYeZiGeZhengHao" size="small"
                               clearable placeholder="从业资格证号"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="司机联系方式:">
                    <div>
                        <Input v-model="rmvehicleinfo.siJiLianXiFangShi"
                               size="small"
                               clearable placeholder="司机联系方式"
                               style="width: 220px;padding: 5px"></Input>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="交强险公司:">
                    <div>
                        <Select
                                size="small"
                                placeholder="交强险公司"
                                v-model="rmvehicleinfo.jiaoQiangXianGongSi"
                                filterable
                                remote
                                :remote-method="searchMLIFTAinsuranceChannel"
                                :loading="searchMLIFTAinsuranceChannelLoading"
                                class="field" style="width: 220px;padding: 5px"
                                placement="top-end"
                                clearable>
                            <Option v-for="(option, index) in searchMLIFTAinsuranceChannelList" :value="option.name"
                                    :key="option.id">{{option.name}}
                            </Option>
                        </Select>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="交强险到期时间:">
                    <div>
                        <DatePicker type="date" v-model="rmvehicleinfo.jiaoQiangXianDaoQiShiJian" size="small"
                                    placeholder="交强险到期时间"></DatePicker>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="商业险公司:">
                    <div>
                        <Select
                                size="small"
                                placeholder="商业险公司"
                                v-model="rmvehicleinfo.shangYeXianGongSi"
                                filterable
                                remote
                                :remote-method="searchTIinsuranceChannel"
                                :loading="searchTIinsuranceChannelLoading"
                                class="field" style="width: 220px;padding: 5px"
                                placement="top-end"
                                clearable>
                            <Option v-for="(option, index) in searchTIinsuranceChannelList" :value="option.name"
                                    :key="option.id">{{option.name}}
                            </Option>
                        </Select>
                    </div>
                </FormItem>
                <FormItem v-if="eligibility" label="商业险到期时间:">
                    <div>
                        <DatePicker type="date" v-model="rmvehicleinfo.shangYeXianDaoQiShiJian" size="small"
                                    placeholder="商业险到期时间"></DatePicker>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div v-else>
            <Form :label-width="60">
                <Row>
                    <FormItem label="身份证/营业执照" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList1">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                                <!--                            <div class="demo-upload-list-cover">-->
                                <!--                                <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>-->
                                <!--                                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>-->
                                <!--                            </div>-->
                            </template>
                        </div>
                        <Upload
                                ref="upload"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList1"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 1">身份证/营业执照</Button>
                            </div>
                        </Upload>
                    </FormItem>
                    <FormItem label="行驶证" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList2">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                            </template>
                        </div>
                        <Upload
                                ref="upload2"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList2"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 2">行驶证</Button>
                            </div>
                        </Upload>
                    </FormItem>
                </Row>
                <Row>

                    <FormItem label="车辆交强险单据" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList3">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                            </template>
                        </div>
                        <Upload
                                ref="upload3"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList3"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 3">车辆交强险单据</Button>
                            </div>
                        </Upload>
                    </FormItem>
                    <FormItem label="车辆商业险单据" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList4">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                            </template>
                        </div>
                        <Upload
                                ref="upload3"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList4"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 4">车辆商业险单据</Button>
                            </div>
                        </Upload>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="车辆状态图片" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList5">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                            </template>
                        </div>
                        <Upload
                                ref="upload3"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList5"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 5">车辆状态图片</Button>
                            </div>
                        </Upload>
                    </FormItem>
                    <FormItem label="承诺函图片" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList6">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                            </template>
                        </div>
                        <Upload
                                ref="upload3"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList6"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 6">承诺函图片</Button>
                            </div>
                        </Upload>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="承诺函背面图片" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList7">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                            </template>
                        </div>
                        <Upload
                                ref="upload3"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList7"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 7">承诺函背面图片</Button>
                            </div>
                        </Upload>
                    </FormItem>
                    <FormItem label="从业资格证图片" style="display: inline-block;">
                        <div class="demo-upload-list" v-for="item in fileList8">
                            <template v-if="item.isImage">
                                <img :src="item.url" @click="onPhotoClick(item)">
                            </template>
                        </div>
                        <Upload
                                ref="upload3"
                                style="width: 100px;"
                                :before-upload="handleBeforeUpload"
                                :default-file-list="fileList8"
                                action="//jsonplaceholder.typicode.com/posts/">
                            <div style="padding: 20px 0">
                                <Button size="small" type="info" @click="pictype = 8">从业资格证图片</Button>
                            </div>
                        </Upload>
                    </FormItem>
                </Row>
            </Form>
        </div>
        <div style=";position: fixed;top: 150px;right: 10px">
            <Button size="small" type="info" @click="showDrawer2 = true" style="margin-right: 5px;">
                填写指引
            </Button>
            <Drawer title="指引" placement="right" :closable="false" v-model="showDrawer2" width="85">
                <div>
                    <img src="../../../public/重货保险免费安装主动安全设备登记-使用文档/图片 1(1).png" height="61" width="266"/>
                    <Divider/>
                    <label style="color:blue;">符合营运资格才可申请保险免费安装主动安全设备</label>
                    <img src="../../../public/重货保险免费安装主动安全设备登记-使用文档/图片 2(1).png" height="73" width="166"/>
                    <Divider/>
                    <label style="color:red;">如有以下情况不可申请保险免费安装主动安全设备</label>
                    <img src="../../../public/重货保险免费安装主动安全设备登记-使用文档/图片 3(1).png" height="63" width="236"/>
                    <img src="../../../public/重货保险免费安装主动安全设备登记-使用文档/图片 4(1).png" height="129" width="216"/>
                    <Divider/>
                    <label style="color:blue;">审核不通过请进行修改，查询修改指引如下</label><br>
                    <img src="../../../public/重货保险免费安装主动安全设备登记-使用文档/图片 9(1).png" height="79" width="208"/>
                    <img src="../../../public/重货保险免费安装主动安全设备登记-使用文档/图片 10(1).png" height="274" width="234"/>
                    <Divider/>
                    <label style="color:red;">如有以下或类似情况，请寻找不符合项修改</label>
                    <img src="../../../public/重货保险免费安装主动安全设备登记-使用文档/图片 11(1).png" height="80" width="244"/>
                    <Divider/>
                </div>
            </Drawer>
        </div>
        <div style=";position: fixed;bottom: 10px;right: 10px">
            <div v-if="showmodify">
                <Button size="small" type="info" @click="modifyRmvehicleinfo" style="margin-right: 5px;">
                    确认修改
                </Button>
                <Button size="small" type="info" v-if="showPic" @click="showPic=false">
                    下一页
                </Button>
                <Button size="small" type="info" v-else @click="backRmvehicleinfo">
                    上一页
                </Button>
            </div>
            <div v-else>
                <Button size="small" type="info" @click="showDrawer = true" style="margin-right: 5px;">
                    查询已登记车辆
                </Button>
                <Button size="small" type="info" v-if="showPic" @click="addRmvehicleinfo">
                    下一页
                </Button>
                <!--            <Button size="small" type="info" v-else @click="backRmvehicleinfo">-->
                <!--                上一步-->
                <!--            </Button>-->
                <Button size="small" type="info" v-else @click="onAccomplish">
                    完成
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import axios from 'axios'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        Uploader,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

    export default {
        name: "vrhicle-free-inquire",
        inject: ['reload'],
        data() {
            return {
                //页面资料/图片显示
                showPic: true,
                //是修改/增加
                showmodify: false,
                //显示抽屉搜索
                showDrawer: false,
                //显示填写指引
                showDrawer2: false,
                //搜索列表
                rmvehicleinfolist: [],

                //交强险选择
                searchMLIFTAinsuranceChannelList: [],
                searchMLIFTAinsuranceChannelLoading: false,

                //商业险选择
                searchTIinsuranceChannelList: [],
                searchTIinsuranceChannelLoading: false,

                //道路运输是否符合
                result: [],
                information: [],
                eligibility: false,
                msg: [],

                chePaiYanSeOptions: [
                    {name: '蓝色', value: 1},
                    {name: '黄色', value: 2},
                    {name: '黑色', value: 3},
                    {name: '白色', value: 4},
                    {name: '绿色', value: 5},
                ],

                certificateAreaOptions: [
                    {name: '中山', value: 1},
                    {name: '江门', value: 2}
                ],

                rmvehicleinfo: {
                    id: null,
                    chePaiHao: null,
                    chePaiYanSe: '黄色',
                    cheJiaHao: null,
                    faDongJiHao: null,
                    area: null,
                    yeHuMingCheng: null,
                    shenFenZhengHaoMa: null,
                    yeHuTongYiSheHuiXinYongDaiMa: null,
                    yeHuFuZeRenXingMing: null,
                    yeHuFuZeRenLianXiFangShi: null,
                    siJiXingMing: null,
                    congYeZiGeZhengHao: null,
                    siJiLianXiFangShi: null,
                    jiaoQiangXianGongSi: null,
                    jiaoQiangXianDaoQiShiJian: null,
                    shangYeXianGongSi: null,
                    shangYeXianDaoQiShiJian: null,
                    businessUserId: null,
                    auditPass: null,
                    remark: null,
                    customerCntact: null,
                    customerCntactPhone: null,
                    /**
                     * 图片部分
                     */
                    idFilePictureId: null,//车主身份证明文件图片id
                    idFilePicture: null,//车主身份证明文件图片
                    vehicleLicensePictureId: null,//行驶证图片id
                    vehicleLicensePicture: null,//行驶证图片
                    mandatoryLiabilityInsuranceForTrafficAccidentsPictureId: null,//车辆交强险单据图片id
                    mandatoryLiabilityInsuranceForTrafficAccidentsPicture: null,//车辆交强险单据图片
                    commercialInsurancePictureId: null,//车辆商业险单据图片id
                    commercialInsurancePicture: null,//车辆商业险单据图片
                    vehicleInfoStatePictureId: null,//车辆状态图片id
                    vehicleInfoStatePicture: null,//车辆状态图片
                    commitmentLetterPictureId: null,//承诺函图片id
                    commitmentLetterPicture: null,//承诺函图片
                    commitmentLetterBackPictureId: null,//承诺函背面图片id
                    commitmentLetterBackPicture: null,//承诺函背面图片
                    qualificationCertificatePictureId: null,//从业资格证图片id
                    qualificationCertificatePicture: null,//从业资格证图片
                },
                //图片列表
                fileList1: [],
                fileList2: [],
                fileList3: [],
                fileList4: [],
                fileList5: [],
                fileList6: [],
                fileList7: [],
                fileList8: [],
                //上传文件七牛
                postParams: {
                    upload_token: null,
                    picKey: null,
                },
                //上传文件
                uploadFile: null,
                //上传文件，图片类型
                pictype: null,

                //iview 上传，图片显示组件
                imgName: '',
                visible: false,
            }
        },
        methods: {
            onPhotoClick(url) {
                // let item = this.pictureRecords[this.currentPictureIndex]
                // console.log(url)
                window.open(url.url)
            },
            handleView(name) {
                this.imgName = name;
                this.visible = true;
            },
            handleRemove(file) {
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            },
            onFind() {
                let q = []
                q.push(genQueryParam('customerCntact', 'EQ', this.rmvehicleinfo.customerCntact))
                q.push(genQueryParam('customerCntactPhone', 'EQ', this.rmvehicleinfo.customerCntactPhone))
                store.dispatch('RmFreeServ_GetPage', {
                    params: {},
                    urlparams: {
                        q: q,
                    },
                }).then(() => {
                    this.rmvehicleinfolist = store.getters.get_RmFree_GetPageResult.content
                    if (this.rmvehicleinfolist.length == 0) {
                        this.$Message.error({
                            content: '没有车辆信息，请检查业户名称或业户联系方式',
                            duration: 5,
                            closable: true
                        })
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            onDetail(e) {
                console.log(e)
                if (e.chePaiHaoUUID != null) {
                    store.dispatch('RmFreeServ_GetPage', {
                        params: {},
                        urlparams: {
                            q: genQueryParam('chePaiHaoUUID', 'EQ', e.chePaiHaoUUID),
                        },
                    }).then(() => {
                        //用移动端无法直接打开新窗口显示详细信息
                        // window.open('http://localhost:8080/vehiclefreeinquire?uuid='+store.getters.get_RmFree_GetPageResult.content[0].chePaiHaoUUID)
                        // window.open('https://wxpa.jianchengjt.com/vehiclefreeinquire?uuid='+store.getters.get_RmFree_GetPageResult.content[0].chePaiHaoUUID)
                        // window.open('https://wxpa.jianchengjt.com/vehiclefreeinquire?uuid=' + store.getters.get_RmFree_GetPageResult.content[0].chePaiHaoUUID)

                        this.rmvehicleinfo = store.getters.get_RmFree_GetPageResult.content[0]
                        this.showDrawer = false
                        this.showmodify = true
                        this.loadPhotoRecords(this.rmvehicleinfo.id)
                        this.inquireOperationModal()
                    }).catch(err => {
                        console.log(err)
                    })
                } else {
                    store.dispatch('RmFreeServ_GetPage', {
                        params: {},
                        urlparams: {
                            q: genQueryParam('chePaiHao', 'EQ', e.chePaiHao),
                        },
                    }).then(() => {
                        //用移动端无法直接打开新窗口显示详细信息
                        // window.open('http://localhost:8080/vehiclefreeinquire?uuid='+store.getters.get_RmFree_GetPageResult.content[0].chePaiHaoUUID)
                        // window.open('https://wxpa.jianchengjt.com/vehiclefreeinquire?uuid='+store.getters.get_RmFree_GetPageResult.content[0].chePaiHaoUUID)
                        // window.open('https://wxpa.jianchengjt.com/vehiclefreeinquire?uuid=' + store.getters.get_RmFree_GetPageResult.content[0].chePaiHaoUUID)

                        this.rmvehicleinfo = store.getters.get_RmFree_GetPageResult.content[0]
                        this.showDrawer = false
                        this.showmodify = true
                        this.loadPhotoRecords(this.rmvehicleinfo.id)
                        this.inquireOperationModal()
                    }).catch(err => {
                        console.log(err)
                    })
                }
            },
            inquireOperationModal() {
                this.information = []
                this.eligibility = false
                this.msg = []
                store.dispatch('VehicleInfoServ_InquireOperation', {
                    params: {
                        registrationNum: this.rmvehicleinfo.chePaiHao
                    }
                }).then(res => {
                    console.log(store.getters.get_VehicleInfo_InquireOperationResult)
                    if (store.getters.get_VehicleInfo_InquireOperationResult) {
                        this.result = store.getters.get_VehicleInfo_InquireOperationResult
                        this.information = this.result[0]
                        this.eligibility = this.result[1]
                        this.msg = this.result[2]
                    }
                }).catch(err => {
                    console.log(store.getters.get_VehicleInfo_InquireOperationResult)
                    if (store.getters.get_VehicleInfo_InquireOperationResult) {
                        this.result = store.getters.get_VehicleInfo_InquireOperationResult
                        this.information = this.result.data[0]
                        this.eligibility = this.result.data[1]
                        this.msg = this.result.data[2]
                    }
                    console.log(err)
                    // this.$Message.error(err)
                })
            },
            //新增锐明保险资料
            addRmvehicleinfo() {
                if (this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian != null && this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian != '') {
                    if (new Date(this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian) < new Date()) {
                        this.$Message.error('交强险已过期')
                        return
                    } else {
                        this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian = new Date(this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian).Format('yyyy-MM-dd')
                    }
                } else {
                    this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian = null
                }
                if (this.rmvehicleinfo.shangYeXianDaoQiShiJian != null && this.rmvehicleinfo.shangYeXianDaoQiShiJian != '') {
                    if (new Date(this.rmvehicleinfo.shangYeXianDaoQiShiJian) < new Date()) {
                        this.$Message.error('商业险已过期')
                        return
                    } else {
                        this.rmvehicleinfo.shangYeXianDaoQiShiJian = new Date(this.rmvehicleinfo.shangYeXianDaoQiShiJian).Format('yyyy-MM-dd')
                    }
                } else {
                    this.rmvehicleinfo.shangYeXianDaoQiShiJian = null
                }
                if (this.rmvehicleinfo.shenFenZhengHaoMa == '') {
                    this.rmvehicleinfo.shenFenZhengHaoMa = null
                }
                if (this.rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa == '') {
                    this.rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa = null
                }
                if (this.rmvehicleinfo.customerCntact == '') {
                    this.rmvehicleinfo.customerCntact = null
                }
                if (this.rmvehicleinfo.customerCntactPhone == '') {
                    this.rmvehicleinfo.customerCntactPhone = null
                }
                store.dispatch('RmFreeServ_AddObj', {
                    params: this.rmvehicleinfo,
                    urlparams: {},
                }).then(() => {
                    console.log(store.getters.get_RmFree_AddObjResult.id)
                    this.showPic = false
                    this.rmvehicleinfo.id = store.getters.get_RmFree_AddObjResult.id
                }).catch(err => {
                    console.log(err)
                    this.$Message.error(err)
                })
            },
            //返回资料页面
            backRmvehicleinfo() {
                this.showPic = true
            },
            //修改锐明保险资料
            modifyRmvehicleinfo() {
                if (this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian != null && this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian != '') {
                    if (new Date(this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian) < new Date()) {
                        this.$Message.error('交强险已过期')
                        return
                    } else {
                        this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian = new Date(this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian).Format('yyyy-MM-dd')
                    }
                } else {
                    this.rmvehicleinfo.jiaoQiangXianDaoQiShiJian = null
                }
                if (this.rmvehicleinfo.shangYeXianDaoQiShiJian != null && this.rmvehicleinfo.shangYeXianDaoQiShiJian != '') {
                    if (new Date(this.rmvehicleinfo.shangYeXianDaoQiShiJian) < new Date()) {
                        this.$Message.error('商业险已过期')
                        return
                    } else {
                        this.rmvehicleinfo.shangYeXianDaoQiShiJian = new Date(this.rmvehicleinfo.shangYeXianDaoQiShiJian).Format('yyyy-MM-dd')
                    }
                } else {
                    this.rmvehicleinfo.shangYeXianDaoQiShiJian = null
                }
                if (this.rmvehicleinfo.shenFenZhengHaoMa == '') {
                    this.rmvehicleinfo.shenFenZhengHaoMa = null
                }
                if (this.rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa == '') {
                    this.rmvehicleinfo.yeHuTongYiSheHuiXinYongDaiMa = null
                }
                if (this.rmvehicleinfo.customerCntact == '') {
                    this.rmvehicleinfo.customerCntact = null
                }
                if (this.rmvehicleinfo.customerCntactPhone == '') {
                    this.rmvehicleinfo.customerCntactPhone = null
                }
                // this.rmvehicleinfo.idFilePicture = null
                // this.rmvehicleinfo.vehicleLicensePicture = null
                // this.rmvehicleinfo.mandatoryLiabilityInsuranceForTrafficAccidentsPicture = null
                // this.rmvehicleinfo.commercialInsurancePicture = null
                // this.rmvehicleinfo.vehicleInfoStatePicture = null
                // this.rmvehicleinfo.commitmentLetterPicture = null
                // this.rmvehicleinfo.commitmentLetterBackPicture = null
                // this.rmvehicleinfo.qualificationCertificatePicture = null
                store.dispatch('RmFreeServ_ModifyObj', {
                    params: this.rmvehicleinfo,
                    urlparams: {},
                }).then(() => {
                    console.log(store.getters.get_RmFree_ModifyObjResult)
                    Toast.success('修改成功')
                    // this.$router.push({
                    //     name: 'login',
                    // })
                    this.reload()
                    this.loadPhotoRecords()
                    // this.showPic = false
                    // this.rmvehicleinfo.id = store.getters.get_RmFree_ModifyObjResult.id
                }).catch(err => {
                    console.log(err)
                    this.$Message.error(err)
                })
            },

            //上传图片前，获取七牛
            handleBeforeUpload(file) {
                console.log('handleBeforeUpload')
                console.log(this.pictype)
                store.dispatch('PictureServ_GetQiniuUploadToken', {
                    params: {head: 'RMVEHICLEINFO'},
                    urlparams: null
                }).then(() => {
                    this.postParams.upload_token = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                    this.postParams.picKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                    this.uploadFile = file
                    this.upload()
                }).catch(err => {
                    this.$Message.error(err)
                })
                return false
            },
            //返回上一页
            onback() {
                this.$router.push({
                    name: 'login',
                })
            },
            onAccomplish() {
                this.reload()
            },
            upload() {
                console.log('开始上传')
                let param = new FormData(); //创建form对象
                param.append('chunk', '0');//断点传输
                param.append('chunks', '1');
                param.append('token', this.postParams.upload_token)
                param.append('key', this.postParams.picKey);
                param.append('file', this.uploadFile, this.uploadFile.name)
                // console.log(this.uploadFile)
                // console.log(this.uploadFile.name)

                let config = {
                    // headers:{'X-Requested-with':'XMLHttpRequest'},
                    // headers:{'Content-Type':'application/json'},
                    headers: {'Content-Type': 'multipart/form-data'},
                    // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                    withCredentials: false
                };

                // console.log(this.postParams.picKey)
                // console.log(this.addPictureRecord.picType)


                axios.post('https://upload-z2.qiniup.com', param, config)
                    .then(response => {
                        // console.log(response);
                        // console.log(response.data);
                        // this.addPictureRecord.picKey = this.postParams.picKey

                        // console.log(this.addPictureRecord)


                        // console.log(this.rmvehicleinfo.id)
                        // console.log(this.postParams.picKey)
                        // console.log(this.pictype)

                        //  未完成的订单
                        //安装订单更换图片
                        store.dispatch('RmFreeServ_UploadInstallorderePicture', {
                            params: {
                                id: this.rmvehicleinfo.id,
                                picKey: this.postParams.picKey,
                                picType: this.pictype,//图片类型数字
                                srcWidth: null,
                                srcHeight: null
                            },
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            Toast.success('更改图片成功')
                            this.uploadFile = null
                            // this.reload()
                            this.loadPhotoRecords()
                        }).catch(err => {
                            Toast('更改图片失败' + err)
                        });

                    }).catch(err1 => {
                    Toast(err1)
                })
            },
            loadPhotoRecords(e) {
                store.dispatch('RmFreeServ_GetDetail', {
                    params: {id: this.rmvehicleinfo.id},
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    // this.fileList.push({
                    //     url:'https://pic.jianchengjt.com/' +  + '?imageView2.jpg'
                    // })


                    let rmfree = store.getters.get_RmFree_GetDetailResult
                    this.rmvehicleinfo = rmfree
                    this.fileList1 = []
                    this.fileList2 = []
                    this.fileList3 = []
                    this.fileList4 = []
                    this.fileList5 = []
                    this.fileList6 = []
                    this.fileList7 = []
                    this.fileList8 = []
                    if (rmfree.idFilePicture) {//车主身份证明文件图片：1
                        this.fileList1.push({
                            id: rmfree.idFilePictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.idFilePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (rmfree.vehicleLicensePicture) {//行驶证图片：2
                        this.fileList2.push({
                            id: rmfree.vehicleLicensePictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.vehicleLicensePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (rmfree.mandatoryLiabilityInsuranceForTrafficAccidentsPicture) {//车辆交强险单据图片：3
                        this.fileList3.push({
                            id: rmfree.mandatoryLiabilityInsuranceForTrafficAccidentsPictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.mandatoryLiabilityInsuranceForTrafficAccidentsPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (rmfree.commercialInsurancePicture) {//车辆商业险单据图片：4
                        this.fileList4.push({
                            id: rmfree.commercialInsurancePictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.commercialInsurancePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (rmfree.vehicleInfoStatePicture) {//车辆状态图片：5
                        this.fileList5.push({
                            id: rmfree.vehicleInfoStatePictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.vehicleInfoStatePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (rmfree.commitmentLetterPicture) {//承诺函图片：6
                        this.fileList6.push({
                            id: rmfree.commitmentLetterPictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.commitmentLetterPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (rmfree.commitmentLetterBackPicture) {//承诺函背面图片：7
                        this.fileList7.push({
                            id: rmfree.commitmentLetterBackPictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.commitmentLetterBackPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (rmfree.qualificationCertificatePicture) {//从业资格证图片：8
                        this.fileList8.push({
                            id: rmfree.qualificationCertificatePictureId,
                            url: 'https://pic.jianchengjt.com/' + rmfree.qualificationCertificatePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }

                    this.show = false
                }).catch((err) => {
                    console.log(err)
                })
            },
            //交强险搜索
            searchMLIFTAinsuranceChannel(input) {
                this.searchMLIFTAinsuranceChannelLoading = true
                if (!input || input.length <= 0) {
                    this.searchMLIFTAinsuranceChannelList = []
                    this.searchMLIFTAinsuranceChannelLoading = false
                } else {
                    store.dispatch('InsuranceChannelServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchMLIFTAinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
                        this.searchMLIFTAinsuranceChannelLoading = false
                    }).catch(err => {
                        this.searchMLIFTAinsuranceChannelLoading = false
                    })
                }
            },
            searchTIinsuranceChannel(input) {
                this.searchTIinsuranceChannelLoading = true
                if (!input || input.length <= 0) {
                    this.searchTIinsuranceChannelList = []
                    this.searchTIinsuranceChannelLoading = false
                } else {
                    store.dispatch('InsuranceChannelServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchTIinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
                        this.searchTIinsuranceChannelLoading = false
                    }).catch(err => {
                        this.searchTIinsuranceChannelLoading = false
                    })
                }
            },
        },
        mounted() {
            if (window.location.href.split('uuid=')[1] != null) {
                this.showmodify = true
                let vehicleuuid = window.location.href.split('uuid=')[1];
                store.dispatch('RmFreeServ_GetPage', {
                    params: {},
                    urlparams: {
                        q: genQueryParam('chePaiHaoUUID', 'EQ', vehicleuuid),
                    },
                }).then(() => {
                    this.rmvehicleinfo = store.getters.get_RmFree_GetPageResult.content[0]
                    this.loadPhotoRecords(this.rmvehicleinfo.id)
                    this.inquireOperationModal()
                }).catch(err => {
                    console.log(err)
                })
            }
            if (window.location.href.split('businessuserid=')[1] != null) {
                // console.log(window.location.href.split('businessuserid=')[1])
                // window.location.href.split('businessuserid=')
                this.rmvehicleinfo.businessUserId = window.location.href.split('businessuserid=')[1]
            }
        }
    }
</script>

<style scoped>
    .bottomdiv {
        width: 100%;
        background-color: #42b983;
        position: absolute;
        bottom: 5px;
        right: 10px;
    }

    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

</style>
